import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import LoginPage from './LoginPage';
import AdminPanel from './AdminPanel';
import SubmissionForm from './SubmissionForm';
import RoleProtectedRoute from './RoleProtectedRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<SubmissionForm />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/belege"
            element={
              <RoleProtectedRoute requiredRole="admin">
                <AdminPanel />
              </RoleProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
